import { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';

export default function useIsInternational() {
  const { state } = useContext(AppContext);

  return state.country != 'US';
}
